import { makeStyles } from '@material-ui/core/styles'
import AccordionBase from '../../../2compounds/AccordionBase'
import { useState } from 'react'
import useLocationList from './useLocationList'

const LocationList = ({
  admin,
  index,
  editMode,
  data,
  formikProps,
  key,
  resetToDefault,
  reorderFields,
  toggleIsHidden,
  updateFieldLabel,
  updateDataType,
  updateCardLabel,
  isCardDirty,
  toggleIsHiddenCard,
  layoutDefaultData
}) => {
  const classes = useStyles({ admin })
  const { label } = data
  const [isOpen, setIsOpen] = useState(true)
  const { viewSwitcher } = useLocationList()

  return (
    <AccordionBase
      label={label} isOpen={admin ? true : isOpen} setIsOpen={setIsOpen} updateCardLabel={(newValue) => updateCardLabel(index, newValue)}
      className={classes.root} admin={admin} index={index} data={data} resetToDefault={resetToDefault} isCardDirty={isCardDirty}
      toggleIsHiddenCard={toggleIsHiddenCard} layoutDefaultData={layoutDefaultData}
    >
      {viewSwitcher(admin)}
    </AccordionBase>
  )
}

export default LocationList

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    height: '100%',
    gridColumn: 'span 8',
    gridRow: 'span 8',
    border: props => props.admin ? `1px dashed ${theme.palette.tertiary.main}` : 'none',
    '& .MuiAccordionDetails-root': {
      margin: '0 20px'
    }
  }

}))
